document.addEventListener("DOMContentLoaded", function () {
  const contactForm = document.getElementById("ContactForm");
  const titleSelect = document.getElementById("ContactForm-title");
  const firstNameInput = document.getElementById("ContactForm-firstName");
  const lastNameInput = document.getElementById("ContactForm-LastName");
  const emailInput = document.getElementById("ContactForm-email");
  const subjectSelect = document.getElementById("ContactForm-subject");
  const messageTextarea = document.getElementById("ContactForm-body");
  const termsCheckbox = document.getElementById("Terms");
  const passwordInput = document.getElementById("password");
  const passwordConfirmInput = document.getElementById("password_confirmation");

  const returnReasonSelect = document.getElementById(
    "ContactForm-Return-Reason"
  );

  // 유효성 검사 메시지 요소 찾기 (존재 여부 확인 추가)
  function getAlertElement(inputElement, className) {
    return inputElement
      ? inputElement.closest(".field")?.querySelector(className)
      : null;
  }

  const titleAlert = getAlertElement(titleSelect, ".c-select__alert");
  const firstNameAlert = getAlertElement(firstNameInput, ".c-input__alert");
  const lastNameAlert = getAlertElement(lastNameInput, ".c-input__alert");
  const emailAlert = getAlertElement(emailInput, ".c-input__alert");
  const subjectAlert = getAlertElement(subjectSelect, ".c-input__alert");
  const messageAlert = getAlertElement(messageTextarea, ".c-textarea__alert");
  const termsAlert = getAlertElement(termsCheckbox, ".c-checkbox__alert");
  const passwordAlert = getAlertElement(passwordInput, ".c-input__alert");
  const passwordConfirmAlert = getAlertElement(
    passwordConfirmInput,
    ".c-input__alert"
  );

  const returnReasonAlert = getAlertElement(
    returnReasonSelect,
    ".c-input__alert"
  );

  const submitButton = document.getElementById("submitButton");
  const submitResetButton = document.getElementById("submitResetButton");

  function validateEmail() {
    if (!emailInput || !emailAlert) return true;
    const emailValue = emailInput.value.trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (emailValue === "") {
      emailAlert.textContent = "Please enter your email.";
      emailAlert.style.display = "block";
      return false;
    } else if (!emailPattern.test(emailValue)) {
      emailAlert.textContent = "Please provide a valid email address.";
      emailAlert.style.display = "block";
      return false;
    } else {
      emailAlert.style.display = "none";
      return true;
    }
  }

  function validatePassword() {
    if (!passwordInput || !passwordAlert) return true;
    if (passwordInput.value.trim() == "") {
      passwordAlert.textContent = "Please enter your password.";
      passwordAlert.style.display = "block";
      return false;
    } else if (passwordInput.value.trim().length < 8) {
      passwordAlert.textContent =
        "Password must be at least 8 characters long.";
      passwordAlert.style.display = "block";
      return false;
    } else {
      passwordAlert.style.display = "none";
      return true;
    }
  }

  function validatePasswordConfirmation() {
    if (!passwordConfirmInput || !passwordConfirmAlert) return true;
    if (passwordConfirmInput.value.trim() == "") {
      passwordConfirmAlert.textContent = "Please enter your confirm password.";
      passwordConfirmAlert.style.display = "block";
      return false;
    } else if (
      passwordConfirmInput.value.trim() !== passwordInput.value.trim()
    ) {
      passwordConfirmAlert.textContent = "Passwords do not match.";
      passwordConfirmAlert.style.display = "block";
      return false;
    } else {
      passwordConfirmAlert.style.display = "none";
      return true;
    }
  }

  function validateResetForm() {
    const validate = validatePassword();
    const validateConfirm = validatePasswordConfirmation();
    return validate && validateConfirm;
  }

  function validateForm() {
    let isValid = true;

    function checkField(input, alertElement) {
      if (!input || !alertElement) return;
      if (input.value.trim() === "") {
        alertElement.style.display = "block";
        isValid = false;
      } else {
        alertElement.style.display = "none";
      }
    }

    checkField(titleSelect, titleAlert);
    checkField(firstNameInput, firstNameAlert);
    checkField(lastNameInput, lastNameAlert);
    checkField(subjectSelect, subjectAlert);

    const urlParams = new URLSearchParams(window.location.search);
    const reason = urlParams.get("reason");
    if (reason == "return") {
      checkField(returnReasonSelect, returnReasonAlert);
    }

    if (reason != "cancel") {
      checkField(messageTextarea, messageAlert);
    }

    if (!validateEmail()) isValid = false;

    if (termsCheckbox && termsAlert) {
      if (!termsCheckbox.checked) {
        termsAlert.style.display = "block";
        isValid = false;
      } else {
        termsAlert.style.display = "none";
      }
    }

    return isValid;
  }

  function addValidationEvent(buttonId, validationFunction, submitButton) {
    const button = document.getElementById(buttonId);
    if (button && submitButton) {
      button.addEventListener("click", function () {
        if (validationFunction()) {
          submitButton.click();
        }
      });
    }
  }

  addValidationEvent("validateButton", validateForm, submitButton);
  addValidationEvent(
    "validateResetButton",
    validateResetForm,
    submitResetButton
  );

  if (messageTextarea) {
    messageTextarea.addEventListener("input", function () {
      const maxLength = 3900;
      const currentLength = messageTextarea.value.length;
      const countDisplay = messageTextarea
        .closest(".field")
        ?.querySelector(".c-textarea__count em");

      if (countDisplay) countDisplay.textContent = currentLength;
      if (currentLength > maxLength) {
        messageTextarea.value = messageTextarea.value.slice(0, maxLength);
      }
    });
  }

  function toggleActiveClass(element) {
    const parentField = element?.closest(".field");
    if (element) {
      if (
        element.tagName === "TEXTAREA" ||
        element.tagName === "INPUT" ||
        element.tagName === "SELECT"
      ) {
        if (element.value.trim() !== "" || element.checked) {
          if (element.tagName === "TEXTAREA") {
            parentField.classList.add("c-textarea--active");
          } else {
            parentField.classList.add("c-input--active");
          }
        } else {
          if (element.tagName === "TEXTAREA") {
            parentField.classList.remove("c-textarea--active");
          } else {
            parentField.classList.remove("c-input--active");
          }
        }
      }
    }
  }

  // 실시간 오류 메시지 처리
  titleSelect?.addEventListener("change", function () {
    if (titleSelect.value !== "") {
      titleAlert.style.display = "none";
    }
    toggleActiveClass(titleSelect);
  });

  firstNameInput?.addEventListener("input", function () {
    if (firstNameInput.value.trim() !== "") {
      firstNameAlert.style.display = "none";
    }
    toggleActiveClass(firstNameInput);
  });

  lastNameInput?.addEventListener("input", function () {
    if (lastNameInput.value.trim() !== "") {
      lastNameAlert.style.display = "none";
    }
    toggleActiveClass(lastNameInput);
  });

  emailInput?.addEventListener("input", function () {
    validateEmail(); // 이메일 유효성 검사
    toggleActiveClass(emailInput);
  });

  subjectSelect?.addEventListener("change", function () {
    if (subjectSelect.value !== "") {
      subjectAlert.style.display = "none";
    }
    toggleActiveClass(subjectSelect);
  });

  messageTextarea?.addEventListener("input", function () {
    if (messageTextarea.value.trim() !== "") {
      messageAlert.style.display = "none";
    }
    toggleActiveClass(messageTextarea);
  });

  termsCheckbox?.addEventListener("change", function () {
    if (termsCheckbox.checked) {
      termsAlert.style.display = "none";
    }
    toggleActiveClass(termsCheckbox);
  });

  passwordInput?.addEventListener("input", function () {
    validatePassword(); // 이메일 유효성 검사
    toggleActiveClass(passwordInput);
  });

  passwordConfirmInput?.addEventListener("input", function () {
    validatePasswordConfirmation(); // 이메일 유효성 검사
    toggleActiveClass(passwordConfirmInput);
  });

  returnReasonSelect?.addEventListener("change", function () {
    if (returnReasonSelect.value !== "") {
      returnReasonAlert.style.display = "none";
    }
    toggleActiveClass(returnReasonSelect);
  });

  const fields = [
    titleSelect,
    firstNameInput,
    lastNameInput,
    emailInput,
    subjectSelect,
    messageTextarea,
    termsCheckbox,
    passwordInput,
    passwordConfirmInput,
    returnReasonSelect,
  ];

  fields.forEach(function (field) {
    toggleActiveClass(field);
  });
});
